import React, { useState } from 'react'
import { FormattedMessage } from 'react-intl'
import { FormGroup } from 'reactstrap'
import styled from 'styled-components'
import _ from 'lodash'

import * as location from '~/constants/location'
import { Show } from '~/components/commons'
import Select from '~/components/Select'
import EditableRow from '~/components/EditableRow'
import OpenHoursRangeInput from './OpenHoursRangeInput'
import useFormikState from '~/hooks/useFormikState'

function OpenHoursField({
  name,
  controller,
  label,
  editableFields,
  onSwitchChange,
}) {
  const switchId = `${name}Switch`

  const [preset, setPreset] = useState({})
  const [schedule, setSchedule] = useFormikState(controller, name)

  function onChangePreset(option) {
    setSchedule(option.value)
    controller.setFieldValue(name, option.value)
    setPreset(option)
  }

  return (
    <>
      <EditableRow
        switchId={switchId}
        onChange={id => {
          if (editableFields?.[switchId]) {
            setPreset({})
            setSchedule([])
          }
          onSwitchChange(id)
        }}
        isChecked={!!editableFields?.[switchId]}
      >
        <FormGroup>
          <label htmlFor={name}>
            <FormattedMessage id={label} />:
          </label>
          <Select
            value={preset}
            onChange={onChangePreset}
            placeholder={
              editableFields?.[switchId]
                ? 'Choose  some presets or customize'
                : ''
            }
            options={location.openHoursPresets}
            isDisabled={!editableFields?.[switchId]}
          />
        </FormGroup>
      </EditableRow>
      <Show condition={!_.isEmpty(schedule)}>
        <OpenRangeInputsWrapper>
          {schedule?.map(
            (day, i) =>
              i % 2 === 0 && (
                <OpenHoursRangeInput
                  id={i}
                  key={i}
                  defaultTimeState={[
                    _.get(controller?.values, name)?.[i],
                    v => {
                      controller.setFieldValue(`${name}.${i}`, v)
                    },
                  ]}
                  aditionalTimeState={[
                    _.get(controller?.values, name)?.[i + 1],
                    v => controller.setFieldValue(`${name}.${i + 1}`, v),
                  ]}
                  day={day}
                />
              )
          )}
        </OpenRangeInputsWrapper>
      </Show>
    </>
  )
}

const OpenRangeInputsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin: 0;

  @media (max-width: 1024px) {
    max-width: 100%;
  }
`

export default React.memo(OpenHoursField)
